export default __webpack_public_path__ + "static/media/empty.6ad77992.jpg";